import { render, staticRenderFns } from "./GalleryThumbnailOverlay.vue?vue&type=template&id=bd57e56e&scoped=true"
import script from "./GalleryThumbnailOverlay.vue?vue&type=script&lang=ts"
export * from "./GalleryThumbnailOverlay.vue?vue&type=script&lang=ts"
import style0 from "./GalleryThumbnailOverlay.vue?vue&type=style&index=0&id=bd57e56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd57e56e",
  null
  
)

export default component.exports